export default "__VITE_ASSET__B0ru4UVh__"